module.exports = __webpack_public_path__ + "static/react-icon-11471e5c8d51418eaa0897c89c964cf2.png";